// import ArmsRum from '@arms/rum-browser';
import ArmsRum from '@arms/rum-browser/dist/browser-sdk.js';
import { useStorage } from '@/hooks/web/useStorage';
const { getStorage } = useStorage("localStorage")
const envMap = {
	production: 'prod', // 生产环境
	test: 'daily', // 测试环境
	development: 'local' // 开发环境
};
console.log('import.meta.env.MODE-----',import.meta.env.VITE_NODE_ENV);
const findMetaTitleByPath = (menus, targetPath) => {

  const normalizedTarget = targetPath.startsWith('/') ? targetPath : `/${targetPath}`
  // 栈迭代，避免递归深度问题
  const stack = [...(menus || [])];
  
  while (stack.length) {
    const node = stack.pop();
    
    // 匹配当前节点
    if (node?.path === targetPath) {
      // 优先取 meta.title，没有则取 metaTitle
      return node.meta?.title ?? node.metaTitle ?? null;
    }
    
    // 有children就展开继续找
    if (node?.children?.length) {
      stack.push(...node.children);
    }
  }

  return null;
};
ArmsRum.init({
  pid: 'a6tadwyn9j@28ea5cf7460dd08',
  endpoint: 'https://a6tadwyn9j-default-cn.rum.aliyuncs.com',
  // 设置环境信息，参考值：'prod' | 'gray' | 'pre' | 'daily' | 'local'
  env: envMap[import.meta.env.VITE_NODE_ENV], 
  // 设置路由模式， 参考值：'history' | 'hash'
  spaMode: 'hash',
  collectors: {
    // 页面性能指标监听开关，默认开启
    perf: true,
    // WebVitals指标监听开关，默认开启
    webVitals: true,
    // Ajax监听开关，默认开启
    api: true,
    // 静态资源开关，默认开启
    staticResource: true,
    // JS错误监听开关，默认开启
    jsError: true,
    // 控制台错误监听开关，默认开启
    consoleError: true,
    // 用户行为监听开关，默认开启
    action: true,
  },
  // 链路追踪配置开关，默认关闭
  tracing: {
    enable: true, // 开启链路追踪，默认关闭
    sample: 100,
    tracestate: true, // 开启tracestate透传，默认开启
    baggage: true, // 开启baggage透传，默认关闭
    allowedUrls:[{
        match: (url) =>
          url.startsWith(import.meta.env.VITE_API_HOST),
          propagatorTypes: ['tracecontext']
    }]
  },
  parseViewName: (url) => {
		try {
			const u = new URL(url);
			let path = u.hash;

      // 处理动态路由
      const roleRouters = getStorage('roleRouters') || []
      if (path) {
        path = path.replace(/^#/, '')  // 移除开头的 #
          .split('?')[0]                // 移除查询参数
          .split('#')[0]                 // 移除可能的 hash 参数
          .trim()                        // 移除首尾空格
      }
      //匹配title
      const metaTitle = findMetaTitleByPath(roleRouters, path) || path;
			// 按优先级返回标题
			if (metaTitle) {
				return `【${metaTitle}】`;
			}
      if (typeof document !== 'undefined' && document?.title) {
        return `【${document.title}】`
      }
			return url;
		} catch (e) {
			return url;
		}
	}
});

export default ArmsRum;